import { render } from "./signup-step-account.vue?vue&type=template&id=bbf7f3d2&ts=true"
import script from "./signup-step-account.vue?vue&type=script&lang=ts"
export * from "./signup-step-account.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__